import { globalStyle, style } from '@vanilla-extract/css';
import {
  fontSizeVars,
  fontWeightVars,
  lineHeightVars,
  spacingVars,
} from '@tundr/ds-foundations';
import { semanticTokenVars } from '@tundr/ds-tokens';

export const containerClass = style({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

export const disabledReasonTriggerClass = style({
  width: '100%',
  cursor: 'not-allowed',
});

globalStyle(`${disabledReasonTriggerClass} > *`, {
  pointerEvents: 'none',
});

export const labelRowClass = style({
  display: 'flex',
  alignItems: 'center',
  gap: spacingVars.xs,
  marginBottom: spacingVars.sm,
});

export const labelTextClass = style({
  display: 'inline-flex',
  alignItems: 'center',
  marginBottom: 0,
  fontSize: fontSizeVars.body.body1,
  lineHeight: lineHeightVars.body.body1,
  fontWeight: fontWeightVars.bold,
  color: semanticTokenVars.content.default.default,
});

export const notRequiredClass = style({
  fontSize: fontSizeVars.body.body3,
  lineHeight: lineHeightVars.body.body3,
  fontStyle: 'italic',
  color: semanticTokenVars.content.subtle.default,
});

export const extraLabelClass = style({
  display: 'inline-flex',
  alignItems: 'center',
  lineHeight: 0,
  color: semanticTokenVars.content.subtle.default,
});

export const labelTrailingClass = style({
  display: 'inline-flex',
  alignItems: 'center',
  marginLeft: 'auto',
  color: semanticTokenVars.content.subtle.default,
});

export const helperTextClass = style({
  marginTop: spacingVars.xs,
  fontSize: fontSizeVars.body.body3,
  lineHeight: lineHeightVars.body.body3,
  color: semanticTokenVars.content.subtle.default,
});

export const errorTextClass = style({
  marginTop: spacingVars.xs,
  fontSize: fontSizeVars.body.body3,
  lineHeight: lineHeightVars.body.body3,
  color: semanticTokenVars.feedback.error.default.base,
});

export const warningTextClass = style({
  marginTop: spacingVars.xs,
  fontSize: fontSizeVars.body.body3,
  lineHeight: lineHeightVars.body.body3,
  color: semanticTokenVars.feedback.warning.default.base,
});

export const labelRowSmallClass = style({
  marginBottom: spacingVars.xs,
});

export const labelTextSmallClass = style({
  fontSize: fontSizeVars.body.body2,
  lineHeight: lineHeightVars.body.body2,
});

export const messageSmallClass = style({
  fontSize: fontSizeVars.body.body2,
  lineHeight: lineHeightVars.body.body2,
});
